import { QueryClient, useMutation } from "@tanstack/react-query";
import toast from "react-hot-toast";
import { createSource } from "../../../api/source";
import { V3GenericErrorHandler } from "../../../api/error-handler";
import { Queries } from "../../../types/queries";

export const getCreateSourceMutation = (queryClient: QueryClient) =>
    useMutation({
        mutationFn: createSource,
        onError: V3GenericErrorHandler(toast.error),
        onSuccess: (_, { skipInvalidateUser }) => {
            queryClient.invalidateQueries({ queryKey: [Queries.Sources] });

            if (!skipInvalidateUser) {
                queryClient.refetchQueries({ queryKey: [Queries.User] });
            }
        }
    });
